<template>
  <span
    :class="[
      `badge badge-${variant}`,
      { 'badge-pill': pill }
    ]"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'BBadge',
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    pill: Boolean
  }
}
</script>
